import { Table } from "../../../../../models/table";
import { CircularProgress, Typography } from "@mui/material";
import {
    useAddManufacturerModelMutation,
  useEditModelOptionByIdMutation,
  useGetModelsByManufacturerIdQuery,
} from "../../../api/systemTables.api";
import { useEffect, useState } from "react";
import { ManufacturerModel } from "../../../../../models/manufacturer-model";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { useErrorBoundary } from "react-error-boundary";

interface SystemTableOptionsProps {
  manufacturerTable: Table;
  returnBack: () => void;
}

function ModelsOptions({ manufacturerTable, returnBack }: SystemTableOptionsProps) {
  
  const { showBoundary } = useErrorBoundary();

  const {
    data: modelsTableOptions,
    isLoading: isFetchingModelsForManufacturer,
  } = useGetModelsByManufacturerIdQuery(manufacturerTable.id);

  const [editModelOption] = useEditModelOptionByIdMutation();
  const [addModelOption] = useAddManufacturerModelMutation();

  const [action, setAction] = useState<string>("browse");
  const [modelsTableOptionsCopy, setModelsTableOptionsCopy] = useState<ManufacturerModel[]>();

  
  useEffect(()=>{

    if(modelsTableOptions){
        setModelsTableOptionsCopy(modelsTableOptions);
    }
        
  },[modelsTableOptions]);


  /**
   * save the edited system option in the state
   * @param event
   * @param tableChanged
   */
  function apdateState( event: React.ChangeEvent<HTMLInputElement>, tableChanged: ManufacturerModel ): void {

    const systemTableOptionsToUpdate = modelsTableOptionsCopy?.map((table) =>
      table.id === tableChanged.id
        ? { ...tableChanged, name: event.target.value }
        : table
    );

    setModelsTableOptionsCopy(systemTableOptionsToUpdate);
  }


  /**
   * add a new model to a manufacturer table
   */
  async function addNewModel(): Promise<undefined> {

    try {
      const modelIndex: number = (modelsTableOptionsCopy?.length ?? 0) + 1;
      await addModelOption({ manufacturerId: manufacturerTable.id, modelIndex});
    } 
    
    catch (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }


  /**
   * save the edited model option in db and store
   * @param option
   */
  async function saveInput(model: ManufacturerModel) {
    try {
      await editModelOption(model);
    } 
    catch (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }


  return (
    <>
      {isFetchingModelsForManufacturer && (
        <CircularProgress
          color="inherit"
          sx={{ display: "block", margin: "auto", padding: 4 }}
        />
      )}

      {!isFetchingModelsForManufacturer && modelsTableOptionsCopy && (
        <>
          <Typography variant="h3" className="title">
            טבלת {manufacturerTable.name}
          </Typography>

          <div className="table-container">
            <table>
              <tbody>
                {modelsTableOptionsCopy?.map((option, index) => (
                  <tr key={index}>
                    <td>{index+1}.</td>
                    <td className="expand">
                      {action === "browse" && option.name}
                      {action === "edit" && (
                        <input
                          value={option.name || ""}
                          onChange={(e) => {
                            apdateState(e, option);
                          }}
                          onBlur={() => {
                            saveInput(option);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="buttons">
            <button onClick={returnBack}>חזור</button>
            {action === "browse" ? (
              <button
                onClick={() => {
                  setAction("edit");
                }}
              >
                עריכה
              </button>
            ) : (
              <button
                onClick={() => {
                  setAction("browse");
                }}
              >
                סיום עריכה
              </button>
            )}
            <button onClick={addNewModel}>הוספת שורה</button>
          </div>
        </>
      )}
    </>
  );
}

export default ModelsOptions;
